import axios from '../utils/axios'

export function getHome() {
  return axios.get('/index-infos')
}

export function getAgentOverview() {
  return axios.post('/user/apiUserAh5Service/agentOverview')
}
export function getProjectAccessRecordsAPI() {
  return axios.post('/user/apiUserAh5Service/getProjectAccessRecords')
}
export function getIndexPanelDataAPI() {
  return axios.post('/user/apiUserAh5Service/indexPanelData')
}
export function getNoticeListAPI(params) {
  return axios.post('/user/apiUserAh5Service/getAnnouncementList', params)
}
export function getAllProfitAPI() {
  return axios.post('/user/apiUserAh5Service/getAllProfit')
}

export function getAgentMean() {
  return axios.post('/user/apiUserAh5Service/agentMean')
}

export function getAgentOverviewJoinBlockApi() {
  return axios.post('/user/apiUserAh5Service/agentOverviewJoinBlock')
}

export function getDefaultAnnouncementApi() {
  return axios.post('/settle/apiSettleAwService/getDefaultAnnouncement')
}
